export const environment = {
  domain: 'auto-net.nl',
  production: true,
  url: 'https://api.auto-net.nl',
  application: 'atn-website',
  password: 'sD*FfVk2JDWx4A6',
};